export default function getSourceUrl() {
  return sessionStorage["referrerUrl"]
    ? sessionStorage["referrerUrl"]
    : location.href
}
